// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1wvuQ","footer":"ModalCreateQualiphyProcedure_footer__2bT_X","additionData":"ModalCreateQualiphyProcedure_additionData__rmjs_"};